import { render, staticRenderFns } from "./ReportSummaryEvalVendor.vue?vue&type=template&id=2070f136&"
import script from "./ReportSummaryEvalVendor.vue?vue&type=script&lang=js&"
export * from "./ReportSummaryEvalVendor.vue?vue&type=script&lang=js&"
import style0 from "./ReportSummaryEvalVendor.vue?vue&type=style&index=0&id=2070f136&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports